// src/orders/TrackOrderView.js
import React, { useState } from 'react';
import { callApi } from '../api/api'; // Import callApi
import OrderTimeline from './OrderTimeline';

const TrackOrderView = () => {
    const [orderId, setOrderId] = useState('');
    const [trackingResult, setTrackingResult] = useState(null);
    const [trackMessage, setTrackMessage] = useState('');

    const handleTrackSubmit = async (e) => {
        e.preventDefault();
        setTrackingResult(null);
        setTrackMessage('');

        try {
            const response = await callApi(`/orders/${orderId}`, 'GET');
            if (response.success && response.order) {
                setTrackingResult(response.order);
            } else {
                setTrackMessage(response.message || 'Order ID not found. Please check and try again.');
            }
        } catch (error) {
            console.error('Error tracking order:', error);
            setTrackMessage('An error occurred while tracking your order. Please try again later.');
        }
    };

    return (
        <section id="track-order" className="page bg-white p-8 rounded-lg shadow-xl">
            <h2 className="text-4xl font-bold text-center text-teal-700 mb-8">Track Your Order</h2>
            <p className="text-center text-gray-700 text-lg mb-6">Enter your unique Order ID below to get real-time updates on its delivery status.</p>
            <div className="max-w-md mx-auto">
                <form onSubmit={handleTrackSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="order-id" className="block text-gray-700 text-lg font-medium mb-2">Order ID</label>
                        <input type="text" id="order-id" name="orderId" className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-lg" placeholder="Enter your order ID" required value={orderId} onChange={(e) => setOrderId(e.target.value)} />
                    </div>
                    <button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 text-xl shadow-md">Track Order</button>
                </form>
                {trackingResult && (
                    <div className="mt-8 p-6 bg-gray-50 rounded-lg">
                        <h3 className="text-2xl font-bold text-teal-700 mb-4">Order Details:</h3>
                        <p className="text-gray-700 text-lg mb-2">Order ID: <span className="font-semibold">{trackingResult.orderId}</span></p>
                        <p className="text-gray-700 text-lg mb-4">Estimated Delivery: <span className="font-semibold">{trackingResult.estimatedDelivery || 'N/A'}</span></p>
                        <OrderTimeline currentStatus={trackingResult.status} />
                    </div>
                )}
                {trackMessage && (
                    <div className="mt-4 text-center text-red-600 font-semibold">
                        {trackMessage}
                    </div>
                )}
            </div>
        </section>
    );
};

export default TrackOrderView;
